module.exports = __webpack_public_path__ + "img/ejemplo_importacion.3e46c578.png";